import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        url: String,
    };

    click() {
        if (this.hasUrlValue) {
            setTimeout(() => {
                window.open(this.urlValue, '_parent');
            }, 500);
        }
    }
}
